import type { FetchParams, Middleware, RequestContext, ResponseContext } from 'generated/api'
import ExternalAuthState from 'services/Authentication/ExternalAuthState'

export const KeycloakAuthMiddleware: Middleware = {
	post(context: ResponseContext): Promise<Response | void> {
		return Promise.resolve(context.response)
	},
	pre(context: RequestContext): Promise<FetchParams | void> {
		return new Promise((resolve, reject) => {
			ExternalAuthState.getToken().then(token => {
				const headers: Headers = new Headers(context.init.headers)
				headers.set('Authorization', `Bearer ${token}`)
				resolve({ url: context.url, init: { ...context.init, headers } })
			}, reject)
		})
	}
}
